import { track } from './send'

export default class Touchstart {
  add (entry) {
    // 只触发一次
    let isTouch = false
    entry.el.addEventListener('touchstart', function () {
      if (!isTouch) {
        isTouch = true
        track([entry.el.trackParams])
      }
    })
  }
}
